import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const DesktopIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Desktop",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.21 2H5.79C3.95 2 2.47 3.5 2.47 5.34v15.33a3.05 3.05 0 0 0 3.04 2.8h20.71c.87 0 1.66-.34 2.25-.89l.09-.07.09-.12c.54-.56.88-1.33.89-2.18V5.34c0-1.84-1.49-3.33-3.32-3.34ZM16 21.6h-.02a1.419 1.419 0 1 1 1.42-1.42c0 .18-.03.34-.09.5-.19.54-.71.92-1.31.92M5.27 5.34c0-.29.23-.52.52-.52h20.42c.29 0 .53.23.53.52v11.67c-.09 0-.19-.01-.3-.01s-.21 0-.31.01H5.27zm15.77 20.47c-.26-.29-.63-.48-1.05-.48h-7.98c-.42 0-.8.18-1.05.48l-1.61 1.86a1.4 1.4 0 0 0-.36.93c0 .77.63 1.4 1.4 1.4h11.24c.77 0 1.4-.63 1.4-1.4 0-.36-.14-.69-.36-.93l-1.62-1.85Z"
    })
  }));
};